

















import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import NavigationLinks from '@/components/Navigation/NavigaitionLinks.vue'
import NavigationSectionToggle from '@/components/Navigation/NavigationSectionToggle.vue'
import { navigationSectionProps } from '@/mixins/navigationSectionProps'
import NavigationSectionDefault from '@/components/Navigation/NavigationSectionDefault.vue'
import NavigationSectionSubpage from '@/components/Navigation/NavigationSectionSubpage.vue'

export default defineComponent({
  name: 'NavigationSection',
  components: {
    NavigationSectionToggle,
    NavigationSectionSubpage,
    NavigationLinks,
  },
  mixins: [navigationSectionProps],
  setup(props) {
    const store = useStore()

    const dividerIsVisible = computed(() => props.options.divider)

    const contentIsHidden = computed(
      () =>
        props.options.hideOnSubpage &&
        store.getters['navigation/GET_IS_SUBPAGE_OPEN']
    )

    const navigationComponent = computed(() => {
      switch (props.options.type) {
        case 'toggle':
          return NavigationSectionToggle
        case 'subpage':
          return NavigationSectionSubpage
        default:
          return NavigationSectionDefault
      }
    })

    return {
      dividerIsVisible,
      contentIsHidden,
      navigationComponent,
    }
  },
})
